import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { SIGNUP_MUTATION, ME_QUERY } from "graphql/APICalls";
import { MapContext } from "providers/MapProvider";
import { PasswordInput } from "components/Helpers";


export default function SignUp(){

  const { updateLocation } = useContext(MapContext);

  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [getSignup, signupMutation] = useMutation(SIGNUP_MUTATION);
  const navigate = useNavigate();

  async function handleSignup(e) {
    e.preventDefault();
    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match');
      return;
    }
    getSignup({
      variables: {name, username, email, password},
      onCompleted: () => { updateLocation(); navigate('/') },
      onError: error => {
        if (error.message.includes('duplicate key error')){
          if (error.message.includes('username')) setErrorMessage('There is already a user by that username')
          if (error.message.includes('email')) setErrorMessage('There is already a user by that email')
        }
      },
      refetchQueries: [ { query: ME_QUERY } ]
    });
  }
  
  return (
    <div className="auto-scrollbar">
      <div className="centerer login-signup-overlay">
        <form className="centered form-1" onSubmit={handleSignup}>
          <label>Name <div className="tooltip">?<div className="tooltip-text">This is the name that other users will see.</div></div></label>
          <input type="text" value={name} autoCapitalize="words" onChange={e => setName(e.target.value)} required/>
          <label>Username</label>
          <input type="text" autoCapitalize="off" value={username} pattern="[a-z0-9_\-\.]{3,}"
            title="Can only contain lowercase letters, digits, underscore, hyphen, or dot. Must be at least 3 characters long."
            onChange={e => setUsername(e.target.value.toLowerCase())} required/>
          <label>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value.toLowerCase().trim())} required/>
          <label>Password</label>
          <PasswordInput showPassword={showPassword} setShowPassword={setShowPassword} password={password} setPassword={setPassword}/>
          <label>Confirm password</label>
          <PasswordInput showPassword={showPassword} setShowPassword={setShowPassword} password={confirmPassword} setPassword={setConfirmPassword}/>
          <div className="wide error-message" style={{display: errorMessage.length ? 'block' : 'none'}}>{errorMessage}</div>
          <button type="submit" disabled={signupMutation.loading}>Sign up</button>
        </form>
      </div>
    </div>
  )
}